import React, { useState } from "react";
import "./CustomPackage.css";

const CustomPackage = () => {
  const [step, setStep] = useState(0);
  const [formData, setFormData] = useState({
    name: "",
    pax: "",
    startDate: "",
    endDate: "",
    destination: "",
    travelMode: "",
    stayType: "",
    activities: "",
    tripFor: "",
    phone: "",
    email: "",
  });
  const [error, setError] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const questions = [
    { key: "name", question: "What's your name?" },
    { key: "pax", question: "Number of travelers?" },
    { key: "startDate", question: "Trip Start Date?" },
    { key: "endDate", question: "Trip End Date?" },
    { key: "destination", question: "Preferred Destination?" },
    { key: "travelMode", question: "Travel Preference (cab, bus, shared)?" },
    { key: "stayType", question: "Accommodation Type (budget, standard, premium)?" },
    { key: "activities", question: "Preferred Activities (comma separated)?" },
    { key: "tripFor", question: "Trip is for (solo, couple, friends, family)?" },
    { key: "phone", question: "Your Phone Number?" },
    { key: "email", question: "Your Email Address?" },
  ];

  const handleNext = () => {
    const currentKey = questions[step].key;
    if (!formData[currentKey]) {
      setError("Kindly fill your Answer before moving forward");
      return;
    }
    setError("");
    if (step < questions.length - 1) {
      setStep(step + 1);
    } else {
      handleSubmit();
    }
  };

  const handleChange = (e) => {
    const { value } = e.target;
    setFormData({ ...formData, [questions[step].key]: value });
  };

  const handleSubmit = async () => {
    try {
      const payload = {
        data: { ...formData }
      };

      const response = await fetch("https://sheetdb.io/api/v1/b2mjbsi9zafec", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });

      if (response.ok) {
        setSubmitted(true);
        setFormData({
          name: "", pax: "", startDate: "", endDate: "",
          destination: "", travelMode: "", stayType: "",
          activities: "", tripFor: "", phone: "", email: ""
        });
        setStep(0);
      } else {
        setError("Submission failed. Try again.");
      }
    } catch (err) {
      console.error("Error:", err);
      setError("Network error occurred.");
    }
  };

  return (
    <div className="custom-package">
      <h2>Get Your Own Holiday Package</h2>
      <p>
        Fill out a few quick details and let us design the perfect holiday package tailored just for you.
      </p>

      {!submitted ? (
        <div className="form-wrapper">
          <div className="form-slide">
            <h3>Single Tap Travel Assistance</h3>
            <h4>Customized Holiday Package</h4>
            <label>{questions[step].question}</label>
            <input
              type="text"
              value={formData[questions[step].key]}
              onChange={handleChange}
              placeholder="Enter your answer"
            />
            {error && <p className="error">{error}</p>}
            <button onClick={handleNext}>Next →
                
            </button>
          </div>
        </div>
      ) : (
        <p className="success-msg">Thank you! Our team will reach out to you shortly.</p>
      )}
    </div>
  );
};

export default CustomPackage;
